import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const HistorySVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="history-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        data-testid="history-svg"
      >
        <defs>
          <path
            id="history"
            d="M32.007 127c4.958-.003 9.002-4.058 8.993-9.017-.01-4.963-4.035-8.983-9-8.983-2.411 0-4.601.948-6.217 2.493L23.99 109.7c-.366-.366-.991-.107-.991.41v5.276c0 .32.26.58.58.58h5.276c.518 0 .777-.625.41-.99l-1.841-1.842c1.195-1.124 2.804-1.812 4.575-1.812 3.69 0 6.677 2.986 6.677 6.677 0 3.69-2.986 6.677-6.677 6.677-1.568 0-3.01-.539-4.149-1.443-.346-.274-.845-.24-1.157.072l-.41.41c-.364.364-.334.967.068 1.291 1.546 1.248 3.513 1.995 5.655 1.993zm2.428-6.158l.356-.458c.295-.38.227-.927-.153-1.222l-1.477-1.15v-3.786c0-.481-.39-.871-.87-.871h-.581c-.481 0-.871.39-.871.87v4.924l2.373 1.846c.38.295.927.227 1.223-.153z"
          />
        </defs>
        <g fill="none" transform="translate(-23 -109)">
          <use fill="#0B0B0B" xlinkHref="#history" />
          <use fill="#070B16" xlinkHref="#history" />
        </g>
      </svg>
    </StyledContainer>
  );
};

export default HistorySVG;
